<p-drawer header="Nuevo grupo de bancos" [(visible)]="visible" [dismissible]="false" [closable]="false" position="right" [style]="{ 'max-width': '500px', width: '90%' }" [closeOnEscape]="false">
  <form [formGroup]="form" class="card border-0">
    <div class="card-body p-0">
      <div class="py-3 d-flex flex-column gap-4">
        <div class="d-flex flex-column gap-2">
          <p-divider align="left" class="m-0">
            <b>Nombre del grupo</b>
          </p-divider>
          <input formControlName="NAME" pInputText class="w-100 h-50px" placeholder="Ej. Grupo principal BBVA" />
        </div>

        <div class="d-flex flex-column gap-2">
          <p-divider align="left" class="m-0">
            <b>Usuarios</b>
          </p-divider>
          <p-multiSelect formControlName="USERS" [options]="listUsers" placeholder="Selecciona uno o más usuarios" scrollHeight="250px" display="chip" styleClass="w-100 h-50px" appendTo="body" />
        </div>

        <div formGroupName="BANK" class="d-flex flex-column gap-3">
          <p-divider align="left" class="m-0">
            <b>Datos de la cuenta bancaria</b>
          </p-divider>

          <div class="d-flex flex-column gap-2">
            <label class="form-label mb-0">Banco</label>
            <input formControlName="BANCO" pInputText class="w-100 h-50px" placeholder="Ej. BBVA, Banamex, Santander..." />
          </div>

          <div class="d-flex flex-column gap-2">
            <label class="form-label mb-0">Titular de la cuenta</label>
            <input formControlName="TITULAR" pInputText class="w-100 h-50px" placeholder="Nombre del titular" />
          </div>

          <div class="d-flex flex-column gap-2">
            <label class="form-label mb-0">Número de cuenta</label>
            <input formControlName="NUMERO_CUENTA" pInputText class="w-100 h-50px" placeholder="10 o 11 dígitos" />
          </div>

          <div class="d-flex flex-column gap-2">
            <label class="form-label mb-0">CLABE interbancaria</label>
            <input formControlName="CLABE" pInputText class="w-100 h-50px" placeholder="18 dígitos" maxlength="18" />
          </div>
        </div>
      </div>
    </div>
  </form>

  <ng-template #footer>
    <div class="d-flex justify-content-end gap-2">
      <p-button label="Cancelar" severity="secondary" (click)="closeDrawer()" [disabled]="isSaving" />
      <p-button label="Guardar" (click)="createBankGroup()" [loading]="isSaving" [disabled]="form.invalid" />
    </div>
  </ng-template>
</p-drawer>
